import React, { useState, useEffect } from "react";
import {
  Box,
  Flex,
  Grid,
  GridItem,
  HStack,
  Image,
  Text,
  Badge,
  Button,
  VStack,
  Divider,
  Spinner,
  Center,
  useBreakpointValue,
  Card,
  CardHeader,
  CardBody,
} from "@chakra-ui/react";
import { FaSync, FaEllipsisV, FaPrint } from "react-icons/fa";
import { BASE_URL } from "../../Globalapi/Globalapi";


const StaffDetails = () => {
  const [staffData, setStaffData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStaffDetails = async () => {
      const user_id = sessionStorage.getItem("user_id"); // Retrieve user_id from sessionStorage

      if (!user_id) {
        setError("User ID not found in session storage.");
        setLoading(false);
        return;
      }

      try {
        const response = await fetch(
          `${BASE_URL}/staff/profile/staff_profile.php?user_id=${user_id}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();
        console.log(data, "sdfsd");

        if (data.success) {
          setStaffData(data.data);
        } else {
          setError(data.message);
        }
      } catch (error) {
        setError("Error fetching staff details.");
      } finally {
        setLoading(false);
      }
    };

    fetchStaffDetails();
  }, []); // Empty dependency array to run once on component mount

  if (loading) {
    return (
      <Center h="100vh">
        <Spinner size="xl" />
      </Center>
    );
  }

  if (error) {
    return (
      <Box p={4} color="red.500" fontWeight="bold">
        {error}
      </Box>
    );
  }

  if (!staffData) {
    return <Box p={4}>No staff data available.</Box>;
  }

  return (
    <div className="teacher-list-container">
        <div className="header">
          <h1 fontSize="20px">Guardian List</h1>
          <div className="action-buttons">
            <Button
              className="refresh-button"
              boxShadow="md" // Applies a medium shadow
              backgroundColor="teal"
              fontSize="11px"
              onClick={() => {
                // Add refresh functionality here
                console.log("Refresh button clicked");
              }}
              display={{ base: "none", md: "flex" }}
            >
              <FaSync color="white" />
            </Button>
            <div className="export-dropdown">
              <Button
                className="export-button"
                color="white" // Set the text color to white
                display={{ base: "none", md: "flex" }}
                backgroundColor="teal"
                fontSize="11px"
                boxShadow="md"
                // onClick={handlePrint}
              >
                <FaPrint color="white" />
                Print PDF
              </Button>
            </div>
          </div>
        </div>

        <div className="breadcrumb">
          <span>Dashboard</span> / <span>Students</span> / <span>Guardian List</span>
        </div>
    <Box p={4}>
      <Grid templateColumns={{ base: "1fr", md: "1fr 2fr" }} gap={4}>
        <GridItem>
          <Card>
            <CardHeader>
              <Flex alignItems="center">
                <Image
                  src={staffData.image_url || "https://via.placeholder.com/150"}
                  alt="Staff"
                  borderRadius="full"
                  boxSize={{ base: "80px", md: "150px" }}
                  objectFit="cover"
                />
                <Box ml={4}>
                  <Text fontWeight="bold" fontSize={{ base: "lg", md: "2xl" }}>
                    {staffData.name}
                  </Text>
                  <Text color="gray.600">Username: {staffData.username}</Text>
                  <Badge colorScheme="green" mt={1}>
                    {staffData.utype === "1" && "Admin"}
                    {staffData.utype === "2" && "Staff"}
                    {staffData.utype === "3" && "Student"}
                  </Badge>
                </Box>
              </Flex>
            </CardHeader>
            <CardBody>
              <VStack align="start" spacing={4}>
                <HStack spacing={4} align="center">
                  <Text fontWeight="bold">Aadhar No:</Text>
                  <Text>{staffData.aadhar_no}</Text>
                </HStack>
                <HStack spacing={4} align="center">
                  <Text fontWeight="bold">Contact No:</Text>
                  <Text>{staffData.contact_no}</Text>
                </HStack>
                <HStack spacing={4} align="center">
                  <Text fontWeight="bold">Email:</Text>
                  <Text>{staffData.email}</Text>
                </HStack>
                <HStack spacing={4} align="center">
                  <Text fontWeight="bold">Gender:</Text>
                  <Text>{staffData.gender}</Text>
                </HStack>
                <HStack spacing={4} align="center">
                  <Text fontWeight="bold">Date Of Birth:</Text>
                  <Text>{staffData.date_of_birth}</Text>
                </HStack>
                <HStack spacing={4} align="center">
                  <Text fontWeight="bold">Date Of Join:</Text>
                  <Text>{staffData.date_of_join}</Text>
                </HStack>
                <HStack spacing={4} align="center">
                  <Text fontWeight="bold">Blood Group:</Text>
                  <Text>{staffData.group}</Text>
                </HStack>
                <HStack spacing={4} align="center">
                  <Text fontWeight="bold">Nation:</Text>
                  <Text>{staffData.nation}</Text>
                </HStack>
                <HStack spacing={4} align="center">
                  <Text fontWeight="bold">State:</Text>
                  <Text>{staffData.state}</Text>
                </HStack>
                <HStack spacing={4} align="center">
                  <Text fontWeight="bold">District:</Text>
                  <Text>{staffData.district}</Text>
                </HStack>
                <HStack spacing={4} align="center">
                  <Text fontWeight="bold">Place:</Text>
                  <Text>{staffData.place}</Text>
                </HStack>
              </VStack>
            </CardBody>
          </Card>
        </GridItem>
        <GridItem>
          <Card>
            <CardHeader>
              <Text fontSize="lg" fontWeight="bold">
                Address
              </Text>
            </CardHeader>
            <CardBody>
              <Text>{staffData.address}</Text>
            </CardBody>
          </Card>
          <Card mt={4}>
            <CardHeader>
              <Text fontSize="lg" fontWeight="bold">
                Parent Information
              </Text>
            </CardHeader>
            <CardBody>
              <Divider mb={2} />
              <Text>
                <strong>Guardian's Name:</strong> {staffData.guardian_name}
              </Text>
              <Text>
                <strong>Guardian's Address:</strong>{" "}
                {staffData.guardian_address}
              </Text>
              <Text>
                <strong>Guardian's Contact:</strong>{" "}
                {staffData.guardian_contact_no}
              </Text>
              <Text>
                <strong>Guardian's Relation:</strong> {staffData.relation}
              </Text>
            </CardBody>
          </Card>
        </GridItem>
      </Grid>
    </Box>
    </div>

  );
};

export default StaffDetails;
